export enum SnackBarMessageType {
	Success = "success",
	Error = "error",
	Warning = "warning",
	Info = "info",
}
